import {
  TableContainer,
  Table,
  Paper,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Box,
  Collapse,
  TextField,
  Chip,
} from "@mui/material";
import { useQuery } from "@apollo/client";
import IconButton from "@mui/material/IconButton";
import { GET_COURSE_SUGGESTIONS } from "pages/courseSuggestions/courseSuggestionQueries";
import { format } from "date-fns";
import React, { useState } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

const ProcessedSuggestionTableRow = ({ row }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <TableRow
        key={row._id}
        sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
      >
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row">
          {row.title}
        </TableCell>
        <TableCell>{row.university}</TableCell>
        <TableCell>{row.suggestedBy?.username}</TableCell>
        <TableCell>
          {format(new Date(parseInt(row.createdAt)), "dd/MM/yyyy HH:mm")}
        </TableCell>

        <TableCell
          style={{
            background: "lightblue",
          }}
        >
          {row.isAccepted ? (
            <Chip label={"Ja"} color={"success"} />
          ) : (
            <Chip label={"Nein"} color={"error"} />
          )}
        </TableCell>

        <TableCell
          style={{
            background: "lightblue",
          }}
        >
          {row.resolvedBy?.username}
        </TableCell>
        <TableCell
          align="right"
          style={{
            background: "lightblue",
          }}
        >
          {format(new Date(parseInt(row.updatedAt)), "dd/MM/yyyy HH:mm")}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell
          style={{
            paddingBottom: 0,
            paddingTop: 0,
            background: "lightgrey",
            width: "100%",
            height: "100%",
          }}
          colSpan={8}
        >
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box
              sx={{
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "space-around",
                alignItems: "center",
              }}
            >
              <TextField
                id="outlined-multiline-static"
                multiline
                rows={4}
                placeholder="Editors comment"
                sx={{ width: "40%", p: 2 }}
                disabled={true}
                value={row.resolvingComment}
              />
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
};

export const ProcessedCourseSuggestionsPage = () => {
  const { data: courseSuggestionsData, loading: isLoadingCourseSuggestions } =
    useQuery(GET_COURSE_SUGGESTIONS, {
      variables: { isResolved: true },
      pollInterval: 5000,
    });

  if (isLoadingCourseSuggestions) {
    return <p>Loading</p>;
  }

  return (
    <>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell></TableCell>
              <TableCell>Modultitel</TableCell>
              <TableCell>Uni</TableCell>
              <TableCell>User</TableCell>
              <TableCell>Datum</TableCell>
              <TableCell
                style={{
                  background: "lightblue",
                }}
              >
                Akzeptiert ?
              </TableCell>
              <TableCell
                style={{
                  background: "lightblue",
                }}
              >
                Editor
              </TableCell>
              <TableCell
                align="right"
                style={{
                  background: "lightblue",
                }}
              >
                Edited at
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {courseSuggestionsData?.courseSuggestions?.courseSuggestions?.map(
              (row) => {
                return <ProcessedSuggestionTableRow key={row._id} row={row} />;
              },
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};
